"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
exports.ContentImportPanelRefreshButton = () => {
    const { contentItemsResult, isLoadingContentItems, contentFeed, } = hooks_1.useContentImportPanelData();
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.inner", flexColCentered: true },
        react_2.default.createElement(react_1.OsmosysButton, { osysName: "ContentImportPanel.refresh", osysIcon: "reload", osysStyle: "navLink", tooltip: "Refresh content feed (bypasses cache for latest content)", className: "p-1", disabled: isLoadingContentItems || !contentFeed, iconSpin: isLoadingContentItems, onClick: () => {
                contentItemsResult.refetch({
                    skipCache: true,
                });
            } })));
};
//# sourceMappingURL=RefreshButton.js.map